export var RefundMode;
(function (RefundMode) {
    RefundMode["Auto"] = "Auto";
    RefundMode["Manual"] = "Manual";
})(RefundMode || (RefundMode = {}));
export var StepType;
(function (StepType) {
    StepType["Passengers"] = "Passengers";
    StepType["Reason"] = "Reason";
    StepType["AttachFiles"] = "AttachFiles";
    StepType["CreateTicket"] = "CreateTicket";
    StepType["Ticket"] = "Ticket";
})(StepType || (StepType = {}));
export var VoluntaryReason;
(function (VoluntaryReason) {
    VoluntaryReason["Voluntary"] = "Voluntary";
})(VoluntaryReason || (VoluntaryReason = {}));
